import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { Icon } from 'ui';

const StepIndicator = ({ id, progress, stepNumber }) => {
  const { completed } = useSelector(state => state);

  const firstIncompleteIndex =
    useSelector(state => state.firstIncompleteIndex) || 0;

  const stepCompleted = !!progress && progress.completedAt;

  return (
    <div
      id={`step-${id}`}
      className={classNames('JourneyContentStep', {
        'JourneyContentCollapsed-step':
          completed || stepNumber < firstIncompleteIndex + 1,
        'JourneyContentStep--completed': stepCompleted,
        'JournalContentStep--incomplete': !completed && !stepCompleted,
      })}
    >
      {!completed &&
        stepNumber >= firstIncompleteIndex + 1 &&
        !stepCompleted && (
          <span className="PathContentStep-position">{stepNumber}</span>
        )}
      {!completed &&
        stepNumber >= firstIncompleteIndex + 1 &&
        stepCompleted && (
          <Icon className="PathContentStep-icon" name="correct" key="1" />
        )}
    </div>
  );
};

export default StepIndicator;
